// extracted by mini-css-extract-plugin
export default {"container":"ConfirmFieldDeletionModal_container__rK6og","paragraph1":"ConfirmFieldDeletionModal_paragraph1__oxPEZ","paragraph4":"ConfirmFieldDeletionModal_paragraph4__RCXTD"};